"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
const handleServerError = () => {
    window.location.assign(config_1.PATH.SERVER_ERROR);
};
exports.default = handleServerError;
